// Komponenty společné pro layout (mobilní menu v headeru apod.)
import '../components/header.js';
import '../components/homepage-video.js';
import '../components/forms.js';
import '../components/reference-slider.js';

/**
 * Lightbox pro zvětšení obrázků referencí (GLightbox – globál z vendor bundle).
 * Každá reference má vlastní galerii přes data-gallery, takže šipky listují
 * jen v rámci dané reference.
 */
function initLightbox() {
    if (typeof GLightbox === 'undefined') return;
    GLightbox({
        selector: '.reference-image',
        loop: true,
        touchNavigation: true,
    });
}

document.addEventListener('DOMContentLoaded', initLightbox);
